import { useCallback, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useIonViewDidEnter } from '@ionic/react'
import { AxiosError } from 'axios'

import { useAmbassadors } from '@/lib/hooks/useAmbassadors'

import { sections } from '../components/UserProfileSections/sections'

export const useProfileSections = ({ subscriptionFeedError }) => {
  const { isAmbassador } = useAmbassadors()
  const { hash } = useLocation()
  const [normalizedSections, setSections] = useState(sections)

  const sectionIndex = useMemo(() => {
    const index = normalizedSections.findIndex(
      (section) => `#${section.name}` === hash
    )

    return index === -1 ? 0 : index
  }, [hash, normalizedSections])

  const handleSetSections = useCallback(() => {
    const noSubscriptionSetupFound =
      (subscriptionFeedError as unknown as AxiosError)?.response?.status === 404

    const normalizedSections = noSubscriptionSetupFound
      ? sections.filter((item) => item.name !== 'subscription')
      : sections

    const whitelistFilterSections = isAmbassador
      ? normalizedSections.filter((item) => item.name !== 'exclusive')
      : normalizedSections.filter((item) => item.name !== 'subscription')

    setSections(whitelistFilterSections)
  }, [isAmbassador, subscriptionFeedError])

  useIonViewDidEnter(() => {
    handleSetSections()
  }, [subscriptionFeedError])

  useEffect(() => {
    handleSetSections()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptionFeedError])

  return {
    normalizedSections,
    sectionIndex,
  }
}
